<div class="card" >
  <app-header titulo="Cadastro de Provisão" descricao="Digite as informações de Provisão"></app-header>

  <div class="formgrid grid p-fluid">
        <div class="field col-4">
          <label for="empresaErp">Empresa ERP: </label>
          <p-dropdown
             appendTo="body"
             [options]="empresas"
             [filter]="true"
             optionValue="empresaErp"
             optionLabel="empresaErp"
             [(ngModel)]="provisao77p.empresaErp"
             dataKey="id" inputId="id"
             placeholder="Código Empresa ERP"
              emptyMessage="Nenhuma código"
              >
            </p-dropdown>
        </div>
        <div class="field col-4">
          <label for="ordem">Ordem: </label>
          <input
            type="text"
            id="ordem"
            maxlength="20"
            pInputText
            [(ngModel)]="provisao77p.ordem"
            required
          />
        </div>
        <div class="field col-4">
          <label for="tipoPropriedade">Tipo Propriedade: </label>
          <input
            type="text"
            id="tipoPropriedade"
            maxlength="2"
            pInputText
            [(ngModel)]="provisao77p.tipoPropriedade"
            required
          />
        </div>
        <div class="field col-4">
          <label for="contaCredito">Conta Credito: </label>
          <input
            type="text"
            id="contaCredito"
            maxlength="20"
            pInputText
            [(ngModel)]="provisao77p.contaCredito"
            required
          />
        </div>
        <div class="field col-4">
          <label for="contaDebito">Conta Débito: </label>
          <input
            type="text"
            id="contaDebito"
            maxlength="20"
            pInputText
            [(ngModel)]="provisao77p.contaDebito"
            required
          />
        </div>
        <div class="field col-4">
          <label for="centroCusto">Centro de Custo: </label>
          <input
            type="text"
            id="centroCusto"
            maxlength="20"
            pInputText
            [(ngModel)]="provisao77p.centroCusto"
            required
          />
        </div>
        <div class="field col-2 pt-4">
          <button
            pButton
            icon="pi pi-save"
            class="p-button-success"
            [label]="provisao77p.id ? 'Atualizar' : 'Salvar'"
            (click)="salvar()"
          ></button>
        </div>
        <div class="field col-2 pt-4">
          <button
           pButton label="Cancelar"
           icon="pi pi-times"
           class="p-button-text"
           (click)="fecharDialog()"></button>
        </div>
  </div>
</div>
